import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { useNavigate, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faBriefcase, faChevronLeft, faMoneyCheckDollar, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faCalendar, faPenToSquare, faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { Tab, Tabs, Modal } from 'react-bootstrap';
import { apiService } from '../../services/apiService';
import { toast } from 'react-toastify';
import AppliedCadidates from './AppliedCadidates';
import ViewedCadidates from './ViewedCadidates';
// import  from 'react-bootstrap/Modal';
function ViewJobBoard() {
    const navigate = useNavigate();
    const { slug } = useParams();
    const permissionstest = JSON.parse(localStorage.getItem('permissions'));
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("description");
    const [previewData, setPreviewData] = useState([]);
    const [submitloader, setSubmitloader] = useState(false);

    const handleBackClick = () => {
        navigate("/job-board");
    };

    useEffect(() => {
        const fetchPreviewData = async () => {
            setLoading(true)
            try {
            const response = await apiService.getRequest(`job-posts/${slug}`);
            if(response && response.success === true){
                // setPreviewData(Array.isArray(response.data) ? response.data : [response.data]);
                setPreviewData(response.data);
                setStatus(response.data.status);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
            } catch (error) {
            console.error('Error fetching group data:', error);
            }finally{
                setLoading(false)
            }
        };
    
        fetchPreviewData();
    }, [slug]);

    const sanitizeAndDisplayHTML = (html) => {
        const sanitizedHTML = html
        return sanitizedHTML;
    };

    const [show, setShow] = useState(false);
    const [selectedJobId, setSelectedJobId] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = (jobId) => {
        setSelectedJobId(jobId);
        setShow(true);
    };

    const [status, setStatus] = useState("");
    const handleStatusChange = (event) => {
        const newStatus = event.target.value;
        setStatus(newStatus);
    
        // Fetch jobs based on selected status
        handleStatus(newStatus);
    };
    const handleStatus = async (statusValue) => {
        try {
            const params = {
                status: statusValue || "",
            };
            const response = await apiService.postRequest(`/job-posts/update/status/${previewData.id}`,params);
            if (response?.success) {
                toast(response.message || 'Status updated successfully!');
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error status:", error);
        }
    };
    const handleDelete = async () => {  
        setSubmitloader(true);
        try {
            const response = await apiService.deleteRequest(`/job-posts/${selectedJobId}`); // Call DELETE API
            if(response && response.success === true){
                handleBackClick();
                toast(response.message || 'Job deleted successfully!');
            }else{
                toast(response.message);
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (err) {
            console.log("Failed to delete member");
        }finally {
            setSubmitloader(false); // Stop loader
        }
        handleClose();
    };
    
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                    <h3>Job Board</h3>
                    <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={handleBackClick}>Job Board</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> {slug}</span>
                </Grid>
                {loading ? 
                <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                    <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                </div> :<>
                <Grid size={{xs:12}} container>
                    <Grid size={{xs:12}} container justifyContent="space-between" className="mt-4">
                        <Grid size={{xs:12}} container alignItems="center" justifyContent="flex-end" className="gap-3 mb-4">
                            {permissionstest && permissionstest.manage_job_post_editor === true &&
                            <select className='setactive_jobsselect' value={status} onChange={handleStatusChange}>
                                <option value="active">Active</option>
                                <option value="inactive">In-Active</option>
                            </select>}
                            {permissionstest && permissionstest.manage_job_post_remover === true &&
                                <button className='registersendbtn2 my-0' onClick={() => handleShow(previewData.id)}><FontAwesomeIcon icon={faTrashCan} /> Delete</button>
                            }
                            {permissionstest && permissionstest.manage_job_post_editor === true && <>
                                <button className='registersendbtn2 my-0' onClick={()=> navigate(`/job-board/edit-job/${slug}`)}><FontAwesomeIcon icon={faPenToSquare} /> Edit</button>
                            </>}
                            <button className='registersendbtn1 my-0' onClick={handleBackClick}><FontAwesomeIcon icon={faChevronLeft} /> Back</button>
                        </Grid>
                        <Grid container size={{xs:12}} justifyContent="space-between" alignItems="center">
                            <Grid container alignItems="flex-start" className="titleadmin_joblist job_viewnames">
                                {previewData && previewData.source === "LinkedIn" ? 
                                    <img src={require("../../assets/sample/linkedin.svg").default} alt='Job Icon'/>:
                                    previewData.source === "Monster" ?
                                    <img src={require("../../assets/sample/monster.svg").default} alt='Job Icon'/>:
                                    previewData.source === "Indeed" ?
                                    <img src={require("../../assets/sample/indeed.svg").default} alt='Job Icon'/>:
                                    previewData.source === "Glassdoor" ?
                                    <img src={require("../../assets/sample/glassdoor.svg").default} alt='Job Icon'/>:
                                    previewData.source === "Dice" ?
                                    <img src={require("../../assets/sample/dice.svg").default} alt='Job Icon'/>:
                                    previewData.source === "Techfetch" ?
                                    <img src={require("../../assets/sample/techfetch.svg").default} alt='Job Icon'/>:
                                    previewData.source === "TekP Intelligence" ?
                                    <img src={require("../../assets/sample/tekp.svg").default} alt='Job Icon'/>:
                                    <img src={require("../../assets/sample/others.svg").default} alt='Job Icon'/>}
                                
                                <div className='jobboard_listtitle'>
                                    <h5 className='tittle_jobswrap' style={{whiteSpace: "wrap"}}>{previewData.title}</h5>
                                    <h6 className='mb-0'>{previewData && previewData.recruiter_company && previewData.recruiter_company !== "" && previewData.recruiter_company !== "unknown" && previewData.recruiter_company }</h6>
                                </div>
                            </Grid>
                            <small className='sour_typeshows'>{previewData.source_of_job}</small>
                        </Grid>
                    </Grid>
                    <Grid size={{xs:12}} container className="viewjob_totboders mt-4">
                        <Grid size={{xs:12}} container className="spans_icons_viewjobs">
                            {previewData && previewData.experience_range && previewData.experience_range !== "" && previewData.experience_range !== "unknown" && previewData.experience_range !== "Unknown" &&
                                <span><FontAwesomeIcon className='job_icons' icon={faBriefcase} /> {previewData.experience_range}</span>
                            }
                            {previewData && previewData.salary && previewData.salary !== "" && previewData.salary !== "unknown" &&
                                <span><FontAwesomeIcon className='job_icons' icon={faMoneyCheckDollar} /> {previewData.salary || "-"}</span>
                            }
                            {previewData && previewData.location && previewData.location !== "" && previewData.location !== "unknown" &&
                                <span><FontAwesomeIcon className='job_icons' icon={faLocationDot} /> {previewData.location}</span>
                            }
                            <span><FontAwesomeIcon className='job_icons' icon={faCalendar} /> {previewData.published_on || "-"}</span>
                        </Grid>
                        <Grid size={{xs:12}} container className="spans_bodcont_viewjobs mt-3">
                            <span>Applicants: <b>{previewData.job_post_application_count || 0}</b></span>
                            <span>Applicants Seen: <b>{previewData.job_post_view_count || 0}</b></span>
                            {previewData && previewData.number_of_openings && previewData.number_of_openings !== "" && previewData.number_of_openings !== "unknown" &&
                            <span>Openings: <b>{previewData.number_of_openings}</b></span>
                            }
                            {previewData && previewData.site_type && previewData.site_type !== "" && previewData.site_type !== "unknown" &&
                            <span>Site Type: <b>{previewData.site_type}</b></span>
                            }
                            {previewData && previewData.job_type && previewData.job_type !== "" && previewData.job_type !== "unknown" &&
                            <span>Job Type: <b>{previewData.job_type}</b></span>
                            }
                            {previewData && previewData.source && <span>Source: <b>{previewData.source}</b></span>}
                            {previewData && previewData.citizenship_status && Array.isArray(previewData.citizenship_status) && previewData.citizenship_status[0] !== "unknown" &&
                            <span>Accepted Citizenship Status: <b>{previewData.citizenship_status?.map((item, index) => (
                                    <span key={index} style={{border:"none",padding:"0px",color:"#000"}}>
                                    {item}
                                    {index !== previewData.citizenship_status.length - 1 && ', '}
                                    </span>
                                ))}</b></span>
                            }
                        </Grid>
                    </Grid>
                    <Grid size={{xs:12}} container className="">
                        <Grid size={{xs:12}} container flexDirection="column" justifyContent="center" className="tab_controllers">
                            <Tabs
                                activeKey={activeTab}
                                onSelect={(key) => setActiveTab(key)}
                                defaultActiveKey="description"
                                id="uncontrolled-tab-example" className="mt-4 drafttabs_tabs"
                                >
                                <Tab eventKey="description" title="Job description">
                                    <h4 className='job_disheader mt-4 w-100'>Job description</h4>
                                    {previewData && previewData.description_html && previewData.description_html !== "" && previewData.description_html !== null ?
                                        <div className='w-100 mb-3 caliberifontsset' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(previewData.description_html) }} />
                                        :
                                        <div className='w-100 mb-3 caliberifontsset' dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(previewData.description) }} />
                                    }
                                </Tab>
                                <Tab eventKey="posterprofile" title="Poster Profile">
                                    <h4 className='job_disheader mt-4'>Poster Profile</h4>
                                    <Grid size={{xs:12}} container>
                                        {previewData && previewData.recruiter_name &&
                                        <Grid size={{sm:6,xs:12}} container flexDirection="column" className="poster_profile_job mt-5">
                                            <span>Recruiter Name</span>
                                            <h5>{previewData.recruiter_name || "No data"}</h5>
                                        </Grid>
                                        }
                                        {previewData && previewData.recruiter_email && Array.isArray(previewData.recruiter_email) && previewData.recruiter_email[0] !== "" && previewData.recruiter_email[0] !== "unknown" &&
                                        <Grid size={{sm:6,xs:12}} container flexDirection="column" className="poster_profile_job mt-5">
                                            <span>Recruiter Email</span>
                                            {previewData && previewData.recruiter_email && previewData.recruiter_email.map((email_list,index)=>(
                                                <h5 key={index}>{email_list}</h5>
                                            ))}
                                        </Grid>
                                        }
                                        {previewData && previewData.recruiter_company && previewData.recruiter_company !== "unknown" &&
                                        <Grid size={{sm:6,xs:12}} container flexDirection="column" className="poster_profile_job mt-5">
                                            <span>Recruiter Company</span>
                                            <h5>{previewData.recruiter_company}</h5>
                                        </Grid>
                                        }
                                        {previewData && previewData.recruiter_phone && previewData.recruiter_phone !== "unknown" &&
                                        <Grid size={{sm:6,xs:12}} container flexDirection="column" className="poster_profile_job mt-5">
                                            <span>Recruiter Phone</span>
                                            <h5>{previewData.recruiter_phone}</h5>
                                        </Grid>
                                        }
                                    </Grid>
                                </Tab>
                                <Tab eventKey="appliedcandidate" title="Applied Candidates">
                                    {activeTab === "appliedcandidate" && <AppliedCadidates/>}
                                </Tab>
                                <Tab eventKey="viewedcandidate" title="Viewed Candidates">
                                    {activeTab === "viewedcandidate" && <ViewedCadidates/>}
                                </Tab>
                            </Tabs>
                        </Grid>
                    </Grid>
                </Grid>
                </>}
            </Grid>
            <Modal
                show={show} 
                onHide={handleClose}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton style={{border:"none"}}>
                    
                </Modal.Header>
                <Modal.Body>
                    <div className='d-flex w-100 flex-column text-center align-items-center job_delete_modal'>
                        <FontAwesomeIcon className='main_trashonpopup' icon={faTrashCan} />
                        <h5>Are you sure want delete this job post</h5>
                        <Grid size={{xs:12}} container justifyContent="space-evenly">
                            <button className='registersendbtn1' onClick={handleClose}>Cancel</button>
                            <button className='registersendbtn2' onClick={handleDelete}>{submitloader ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Delete'}</button>
                        </Grid>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    </div>
  )
}

export default ViewJobBoard
